import ToolbarButton from "@/components/ToolbarButton";
import { ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { CopyPlus } from "lucide-react";
import { forwardRef } from "react";
import { useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { QuestionsFromTemplateDialog } from "../../QuestionsFromTemplateDialog";

interface AddQuestionsFromTemplateButtonProps extends ButtonProps {
  labelClassName?: string;
  insertAt?: number;
  label?: string;
}

export default forwardRef<
  HTMLButtonElement,
  AddQuestionsFromTemplateButtonProps
>(function AddQuestionsFromTemplateButton(
  {
    label,
    labelClassName,
    insertAt,
    ...props
  }: AddQuestionsFromTemplateButtonProps,
  ref,
) {
  const { t } = useTranslation();
  const { isSubmitting, disabled } = useFormState();

  return (
    <QuestionsFromTemplateDialog insertAt={insertAt}>
      <ToolbarButton
        type="button"
        ref={ref}
        disabled={isSubmitting || disabled}
        {...props}
      >
        <CopyPlus className="w-5 h-5" />
        <span className={cn("ml-3", labelClassName)}>
          {label ? label : t("surveyEditor.toolbar.addQuestionsFromTemplate")}
        </span>
      </ToolbarButton>
    </QuestionsFromTemplateDialog>
  );
});
